<template>
    <div class="chart-container-wrapper">
        <div
            class="chart-container"
            :style="{ marginBottom: maxMinValue + 'px' }"
        >
            <div class="chart-container-inner">
                <RockChartBar
                    v-for="bonus in bonusses"
                    :key="bonus.month"
                    :data="bonus"
                    :active="bonus == selectedBonus"
                    :max="max"
                    :min="min"
                    :show-year-divider="bonus.month === 12"
                    :year="yearText"
                />
            </div>
        </div>
    </div>
</template>
<script>
import RockChartBar from '@/components/RockChartBar';
import RockChartBarYear from '@/components/RockChartBarYear';

export default {
    components: {
        RockChartBar,
        RockChartBarYear
    },
    props: ['bonusses', 'year', 'selectedBonus'],
    data() {
        return {
            max: 0,
            min: 0
        };
    },
    computed: {
        maxMinValue: function () {
            const min = this.min < 0 ? this.min * -1 : 0;
            const max = Math.max(this.max, min);
            return Math.round((min / max) * 200);
        },
        yearText: function () {
            if (this.year) {
                const endDate = new Date(this.year.endDate);
                return endDate.getFullYear().toString();
            }
            return '';
        }
    },
    watch: {
        bonusses: function () {
            this.calculateMaxMinValues();
        }
    },
    // Fetches posts when the component is created.
    mounted() {
        this.calculateMaxMinValues();
    },
    methods: {
        calculateMaxMinValues: function () {
            if (this.bonusses && this.bonusses.length > 0) {
                this.max = Math.max.apply(
                    Math,
                    this.bonusses.map(function (o) {
                        return Math.max(o.bonus, o.expectedBonus);
                    })
                );

                this.min = Math.min.apply(
                    Math,
                    this.bonusses.map(function (o) {
                        return Math.min(o.bonus, o.expectedBonus);
                    })
                );
            }
        }
    }
};
</script>
